import { render, staticRenderFns } from "./KundenExportierenComponent.vue?vue&type=template&id=de52c9d8&"
import script from "./KundenExportierenComponent.vue?vue&type=script&lang=js&"
export * from "./KundenExportierenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports